import { Col, Row } from "antd";
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth, useNavigation } from '../../components/Auth';
import { useContext, useUserContext } from '../../components/Context';
import { errorCatch, GetAnswer, JSXMap, QueryDetail, QueryParam, READWITH } from '../../components/Tool';

var _ = require('lodash');

function LineDescription(props) {
    const { title, value, unit, bold } = props;
    return (
        <div style={{paddingBottom: "10px"}}>
            <span style={(bold) ? { fontWeight: "600", fontSize: "18px" } : {}}>
                {title} {value} {unit}
            </span>
        </div>
    );
}
function Description(props) {
    const { title, value, unit } = props;
    return (
        <div style={{paddingBottom: "10px"}}>
            <div style={{ fontWeight: "600", fontSize: "18px" }}>
                {title}:
            </div>
            <div>
                {value} {unit}
            </div>
        </div>
    );
}
export default function ServiceDoneDescription(props) {
    let { num } = useParams();
    const auth = useAuth();
    const navigation = useNavigation();
    const user = useUserContext();
    const context = useContext();
    const [sortDefinition, setSortDefinition] = useState();

    useEffect(() => {
        READWITH(auth, "Sorts",
            [
                QueryDetail("model"),
                QueryParam("w-ID", num)
            ],
            (res) => setSortDefinition(res.data),
            errorCatch
        );
    }, []);
    const answers = GetAnswer(context, 1);
    return (<>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
            <Col className="gutter-row" span={24}>
                {JSXMap(answers, (q, idx) => (
                    <div key={idx} style={{ fontWeight: "600", fontSize: "22px", color: "rgb(114, 114, 114)" }}>
                        Культура: {q.answerDisplay}
                    </div>
                ))}
                {JSXMap(sortDefinition, (q, idx) => (
                    <div key={idx} style={{ paddingBottom: "20px" }}>
                        <LineDescription title={"Сорт:"} value={q.name} bold={true} />
                        <LineDescription title={"Внесен в госреестр селекционных достижений в"} value={q.reestrYear} unit={"году"} />
                        <Description title={"Регионы допуска"} value={q.regions} />
                        <Description title={"Оригинаторы"} value={q.creators} />
                        <Description title={"Описание"} value={q.description} />
                        <Description title={"Характеристики"} value={q.charact} />
                        <Description title={"Устойчивость к болезням и вредителям"} value={q.weakness} />
                        <Description title={"Средняя урожайность"} value={q.yield} unit={"ц/га"} />
                    </div>
                ))}
            </Col>
        </Row>
    </>);
}